import { useEffect, useState } from 'react';

type Props = {
    setStatus: (status: string) => void;
    status: string;
    statusTabs: {
        label: string;
        status: string;
    }[];
    statusCounts: any;
};

function FundRequestStatusTabs({
    status,
    setStatus,
    statusTabs,
    statusCounts,
}: Props) {
    const [totalCount, setTotalCount] = useState(0);
    const defaultClasses =
        'flex items-center group shrink-0 px-4 py-2 text-center text-sm text-[#131212] md:text-base lg:px-6 hover:text-primary border-b-2 border-transparent hover:border-primary transition-all';
    const activeClasses = 'text-primary font-bold cursor-default border-b-2 border-primary';
    const inactiveClasses = 'bg-transparent';
    const badgeClasses =
        'font-extrabold ml-2 inline-flex text-[12px]/[12px] px-[4px] py-[1px] text-inherit';
    const badgeActiveClasses = 'text-primary';

    useEffect(() => {
        if (statusCounts) {
            // Calculate the total by summing up all the status counts except the total property
            const sum = Object.entries(statusCounts)
                .filter(([key]) => key !== 'total' && key !== '')
                .reduce((acc, [_, value]) => acc + (value as number), 0);

            setTotalCount(sum);
        }
    }, [statusCounts]);

    return (
        <div
            className='my-3 w-full overflow-x-auto px-6 py-3 '
            style={{ background: 'transparent', borderBottom: '1px solid #e2e8f0' }}
        >
            <div className='flex whitespace-nowrap'>
                {statusTabs.map((tab, index) => (
                    <button
                        key={index}
                        className={`${defaultClasses} ${tab.status === status
                            ? activeClasses
                            : inactiveClasses
                            }`}
                        onClick={() => setStatus(tab.status)}
                    >
                        {tab.label}
                        <span
                            className={`${badgeClasses} ${tab.status === status ? badgeActiveClasses : ''
                                }`}
                        >
                            {tab.status === ''
                                ? totalCount
                                : tab.status === 'open'
                                    ? totalCount
                                    : statusCounts?.[tab.status] || 0}
                        </span>
                    </button>
                ))}
            </div>
        </div>
    );
}

export default FundRequestStatusTabs;
